import { Button, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import Search from '../../../globalComponents/Search';
import Pagination from '../../../globalComponents/Pagination';
import Axios from '../../utils/axios';
import Filters from '../../../globalComponents/Filters';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
    render: (_, record) => <span className={record.type === 'internal' ? 'text-red-500' : ''}>{record.type === 'view' ? record.name : record.parent_location + ' / ' + record.name}</span>
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
    render: (_, record) => <span className={record.type === 'internal' ? 'text-red-500' : ''}>{record.type}</span>
  },
  // {
  //   title: 'Inventory Frequency',
  //   dataIndex: 'inventory_frequency',
  //   key: 'inventory_frequency',
  //   className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  //   render: (_, record) => <span className={record.type === 'internal' ? 'text-red-500' : ''}>{record.inventory_frequency}</span>
  // },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/locations/'+record.seo}>
        EDIT
      </Link>
    )
  }
]

const items = [
  {key: 'internal', label: 'Internal'},
  {key: 'customer', label: 'Customer'},
  {key: 'vendor', label: 'Vendor'},
];

const Locations = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [searchLocations, setSearchLocations] = useState({locations: loader.locations ? loader.locations : [], totalRows: loader.totalRows});
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/inventory/locations/'+record.seo)
    };
  }

  const handleChange = (e, option) => {
    let value_ = e.map(item => item.toLowerCase());
    setSearch(value_)
  }

  async function fetchUserList(search, pagination_, selectedFilters) {

    return Axios(`locations/search?seo=${search}&&pagination=${JSON.stringify(pagination_)}&&filter=${JSON.stringify(selectedFilters)}`)
      .then((response) => response.data)
      .then((res) => {
        setSearchLocations(res);
      });
  }

  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {values: search, filters: selectedFilters}};
    fetchUserList(search, pagination_, selectedFilters);
  },[search, paginations, selectedFilters])

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Locations</h3>
        <div className='w-1/2 bg-white dark:bg-gray-900'>
          <Search search={search.length > 0 ? search : null} handleChange={handleChange}/>        
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/locations/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-between'>
            <Filters items={items} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
            <Pagination paginations={paginations} total={searchLocations.totalRows} setPaginations={setPaginations} />
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowKey={'seo'}
        rootClassName='hover:cursor-pointer'
        dataSource={searchLocations.locations}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Locations;